import React, { useEffect, useState, Fragment } from "react";
import queryString from "query-string";
import axios from "axios";
import { Modal } from 'reactstrap';
import { withRouter } from 'react-router-dom'

import EmailForm from "./EmailForm";
import EmailFormHosted from "./EmailFormHosted";
import PhoneForm from "./PhoneForm";
import CoRegForm from "./CoReg";
import TermsTextLanguage from "./TermsAndConditions";
import EasyApplyForm from "./EasyApply";
import UploadResumeFile from "./ResumeFileUpload";
import UploadResume from "./UploadResumeOptions";
import CustomForm from "./CustomForm/index";
import OffersOverlay from "./OffersOverlay";

const RegOverlay = ( props ) => {
    const [page, setPage] = useState('email');
    const [showPhone, setShowPhone] = useState(true);
    const [email, setEmail] = useState(props.userEmail);
    const [phone, setPhone] = useState(props.userPhone);
    const [fname, setFName] = useState(props.userFName);
    const [lname, setLName] = useState(props.userLName);
    const [recentJob, setRecentJob] = useState('');
    const [recentCompany, setRecentCompany] = useState('');
    const [fileName, setFileName] = useState('');
    const [loading, setLoading] = useState(false);
    const [zip, setZip] = useState('');
    const [seStVal, setSeStVal] = useState('hi');
    const [uType, setUType] = useState('new');
    const qs = queryString.parse(window.location.search);
	const [currentOffer, setCurrentOffer] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(true);
    let hostedType = props.trafficType;
    let fullDomainOut = window.location.hostname;
    fullDomainOut = fullDomainOut.replace("www.","").replace("stage.","");
    let domainOut = window.location.hostname;
	domainOut = domainOut.replace("www.","").replace("stage.","").replace(".com","").replace(".net","").replace(".careers","");
    const [backdrop, setBackdrop] = useState(props.jobPage === "8" && (props.qs.seSt === "hlg" || props.qs.seSt === "bhlg") ? true : 'static')

    const finalLoc = props.jobLocation;
    const pageCID = props.CID;
    const seJk = props.seJk;
    const SID = props.SID;

    useEffect(() => {
        if(qs && qs.seSt && qs.seSt){
            setSeStVal(qs.seSt);
        }
        if(props.duplicateUser === true){
            setUType('repeat');
        }
    }, [qs]);

    const offerGoNext = () => {
        
	    window.scrollTo(0, 0);
	    
	    setIsModalOpen(false);
		document.querySelector("#offerLoad").classList.add('in');

      	var getStr = process.env['REACT_APP_API_URL'] + "/search/cmpForward.fsn?"+parsedQuery+"&OID=7273&domain=upward.careers&source=job&headerImage=http%3A%2F%2Fwww.upward.careers%2Fimages%2FlogoOfferLong.gif&catId="+props.catid+"&userType="+uType+"&abbr=upward&"+1*new Date();

       	axios.get(getStr).then((response) => {
       		document.querySelector("#offerLoad").classList.remove('in');
	       if (response.data && !response.data.includes("window.top.location")) {
	         setCurrentOffer(response.data);
	         props.ccT(8556, 1, props.CID, props.SID, props.isMobile);
	       } else {
            window.location = process.env['REACT_APP_API_URL'] + "/search/cmpForward.fsn?"+parsedQuery+"&OID=7273&domain=upward.careers&source=job&headerImage=http%3A%2F%2Fwww.upward.careers%2Fimages%2FlogoOfferLong.gif&catId="+props.catid+"&userType="+uType+"&abbr=upward&"+1*new Date();
	         setIsModalOpen(false);
	       }
	    }).catch(function (error) {
				window.Rollbar.error("offer error", error);
				// redirect to results 
				window.location = process.env['REACT_APP_API_URL'] + "/upward/resultsRedirect.jsp?job_title="+props.jobTitle+"&job="+props.jobSearch+"&location="+props.jobLocation+"&OID=3726&job_category=&seSt="+seStVal+"&seJk="+props.seJk;
	    })
    }

    let returnUrl = process.env['REACT_APP_API_URL'] + "/upward/resultsRedirect.jsp?job_title="+props.jobTitle+"&job="+props.jobSearch+"&location="+props.jobLocation+"&OID=3726&job_category=&seSt="+seStVal+"&seJk="+props.seJk;

    let query = {
        "pageOID": props.XOID,
        "solrJtid": props.solrJtid,
        "ueid": props.ueid,
        "CRID": props.crid,
        "CID": props.CID,
        "SID": props.SID,
        "job": props.jobSearch,
        "location": props.jobLocation,
        "city": props.jobCity,
        "state": props.jobState,
        "zip": props.jobZip,
        "home_phone": phone.replace(/[^0-9]/g, ''),
        "fname": fname,
        "lname": lname,
        "email": email,
        "job_title": props.jobTitle,
        "siteId": props.siteId,
        "domain": "upward.careers",
        "keyMapId": props.keymapid,
        "userId": props.userId,
        "LOOKUP": "homeCarrier",
        "return_url": encodeURIComponent(returnUrl),
        "actUserApply" : true,
        "seSt": seStVal,
    }

    let query2 = {
        "CID": props.CID,
        "SID": props.SID,
        "checkSMS": "y",
        "phone": phone.replace(/[^0-9]/g, ''),
        "_": 1592592293232
    }

    // Removing empty params
    Object.keys(query).forEach(k => (!query[k] && query[k] !== undefined) && delete query[k]);
    Object.keys(query2).forEach(k => (!query2[k] && query2[k] !== undefined) && delete query2[k]);

    const parsedQuery = Object.keys(query).map(key => key + '=' + query[key]).join('&');
    const queryString2 = Object.keys(query2).map(key => key + '=' + query2[key]).join('&');

    var queryString3 = new FormData();
    queryString3.append('home_phone', phone.replace("-", ""));
    queryString3.append('cptid', props.cptid);
    queryString3.append('cid', props.CID);
    queryString3.append('siteId', props.siteId);
    queryString3.append("oid", props.OID);
    queryString3.append('JFORGID', props.JFORGID);
    queryString3.append('jobId', props.seJk);
    queryString3.append('feedId', props.FID);
    queryString3.append('alertSession', 'false');
    queryString3.append('catId', props.catid);
    queryString3.append('fname', fname);
    queryString3.append('lname', lname);
    queryString3.append('email', email);
    queryString3.append('phoneData', phone.replace("-", ""));

    function onFormSubmit(val) {
        return setPage(val);
    };

    function showLoad() {
        setLoading(true);
    }
    
    function hidePhone(){
        setShowPhone(false);
    }

    function hideLoad() {
        setLoading(false);
    }

    function goResults2() {
        if (((props.jobPage === "7" ||  props.jobPage === "job") && hostedType.toLowerCase() !== "hosted") || (qs && (qs.skip === "pop" || qs.skip === "pop2"))) {
            try {
                window.open( props.jobURL );
            } catch (e) {

            }
        }
        if (props.profileLoc === "T") {
            if(props.jobPage === "8"){
                window.location = props.redirectBaseUrl + '/results/?job=' + props.jobSearch + '&location=&OID=3726&CID=' + pageCID + '&SID=' + SID + '&seJk=' + seJk + '&sePr=SPONSOR&fbn=true&seSt='+(seStVal !== "bhlg" ? seStVal : "hi");
            }else if(hostedType.toLowerCase() === "hosted_plus"){
                window.location = props.redirectBaseUrl + '/results/?job=' + props.jobSearch + '&location=&OID=1313&CID=' + pageCID + '&SID=' + SID + '&seJk=' + seJk + '&hostedPlus=true&sePr=SPONSOR&fbn=true&seSt='+(seStVal !== "bhlg" ? seStVal : "hi")+'&JFORGID='+(qs && qs.JFORGID && qs.JFORGID !== "" ? qs.JFORGID : "")+'&L5_TID='+(qs && qs.L5_TID && qs.L5_TID !== "" ? qs.L5_TID : "");
            }else{
                window.location = props.redirectBaseUrl + '/results/?job=' + props.jobSearch + '&location=&OID=1313&CID=' + pageCID + '&SID=' + SID + '&seJk=' + seJk + '&sePr=SPONSOR&fbn=true&seSt='+(seStVal !== "bhlg" ? seStVal : "hi");
            }
        } else {
            if(props.jobPage === "8"){
                window.location = props.redirectBaseUrl + '/results/?job=' + props.jobSearch + '&location=' + finalLoc + '&OID=3726&CID=' + pageCID + '&SID=' + SID + '&seJk=' + seJk + '&sePr=SPONSOR&fbn=true&seSt='+(seStVal !== "bhlg" ? seStVal : "hi");
            }else if(hostedType.toLowerCase() === "hosted_plus"){
                window.location = props.redirectBaseUrl + '/results/?job=' + props.jobSearch + '&location=' + finalLoc + '&OID=1313&CID=' + pageCID + '&SID=' + SID + '&seJk=' + seJk + '&hostedPlus=true&sePr=SPONSOR&fbn=true&seSt='+(seStVal !== "bhlg" ? seStVal : "hi")+'&JFORGID='+(qs && qs.JFORGID && qs.JFORGID !== "" ? qs.JFORGID : "")+'&L5_TID='+(qs && qs.L5_TID && qs.L5_TID !== "" ? qs.L5_TID : "");
            }else{
                window.location = props.redirectBaseUrl + '/results/?job=' + props.jobSearch + '&location=' + finalLoc + '&OID=1313&CID=' + pageCID + '&SID=' + SID + '&seJk=' + seJk + '&sePr=SPONSOR&fbn=true&seSt='+(seStVal !== "bhlg" ? seStVal : "hi");
            }
        }
    }

    const onCloseModal = e => {
        props.setShowRegOverlay(false);
    }

    const onCloseModalViaBackgroundClick = e => {
        offerGoNext();
    }

    return (
    	<>
        <Modal isOpen={isModalOpen} backdrop={backdrop} toggle={onCloseModalViaBackgroundClick} keyboard={false}>
        	<div id="registerOverlayWrapper">
                <div className="registerOvarlayContent">
                    {
                        (page === "email" && (hostedType.toLowerCase() === "hosted" || hostedType.toLowerCase() === "hosted_plus"))
                        &&
                            <button
                                type="button"
                                className="close btnAltClose"
                                onClick={() => onCloseModal()}
                            >×</button>
                    }
	                {
	                    (page === "email" || page === "number" || page === "alerts") &&
	                    <Fragment>
	                        <h2 className="jobTitle">{props.jobTitle}</h2>
	                        <h4 className="jobLocation">{props.jobCompany}</h4>
	                    </Fragment>
	                }
	                {
	                    (page === "customForm") &&
	                    <Fragment>
	                        <button type="button" className="close btnAltClose float-right" onClick={() => onFormSubmit('applicationComplete')}>×</button>
	                        <h2 className="customFormHead" style={{fontSize:'32px'}}>Additional application questions</h2>
	                    </Fragment>
	                }
	                {
	                    (page === "email" && (hostedType.toLowerCase() === "hosted" || hostedType.toLowerCase() === "hosted_plus"))
	                    &&
	                    <Fragment>
	                        <p>How should the hiring manager contact you?</p>
	                        <EmailFormHosted sessionId={props.sessionId} setLoggedIn={props.setLoggedIn} termsText={props.termsText} jobSearch={props.jobSearch} jobLocation={props.jobLocation} jobTitle={props.jobTitle} sid={props.SID} hasResume={props.hasResume} cid={pageCID} qs={qs} seJk={seJk} hostedType={hostedType} queryString2={queryString2} recentJob={recentJob} recentCompany={recentCompany} onFormSubmit={onFormSubmit} updateEmail={setEmail} email={email} updatePhone={setPhone} phone={phone} fname={fname} lname={lname} updateFName={setFName} updateLName={setLName} queryString={parsedQuery} queryString3={queryString3} loading={loading} showLoad={showLoad} hideLoad={hideLoad} redirectBaseUrl={props.redirectBaseUrl} />
	                    </Fragment>
	                }
	                {
	                    (page === "email" && (hostedType.toLowerCase() === "direct" || (hostedType.toLowerCase().toLowerCase() !== "hosted" && hostedType.toLowerCase() !== "hosted_plus") || (hostedType.toLowerCase() === "")))
	                    &&
	                    <Fragment>
	                        { (props.jobTitle && props.jobCompany && qs && qs.skip && (qs.skip === "x" || qs.skip === "pop")) &&
                             <button
	                            type="button"
	                            style={{"position": "relative", "bottom": "84px", "left": "20px", fontSize: "2rem"}}
	                            className="close btnClose"
	                            onClick={((hostedType.toLowerCase() === "hosted" || hostedType.toLowerCase() === "hosted_plus") ? () => onFormSubmit('customForm') : (props.jobPage === "8" ? () =>  offerGoNext() : () => goResults2()))}
	                        >×</button>
                            } 
                            { (!props.jobTitle && !props.jobCompany && qs && qs.skip && (qs.skip === "x" || qs.skip === "pop")) &&
                            <button
                                type="button"
                                style={{"position": "relative", "bottom": "0px", fontSize: "2rem"}}
                                className="close btnClose"
                                onClick={((hostedType.toLowerCase() === "hosted" || hostedType.toLowerCase() === "hosted_plus") ? () => onFormSubmit('customForm') : (props.jobPage === "8" ? () =>  offerGoNext() : () => goResults2()))}
                            >×</button>
                            }
	                        <p>What email address should a hiring manager use to contact you?</p>
	                        <EmailForm termsText={props.termsText} sessionId={props.sessionId} setLoggedIn={props.setLoggedIn} setShowRegOverlay={props.setShowRegOverlay} jobSearch={props.jobSearch} jobLocation={props.jobLocation} jobTitle={props.jobTitle} sid={props.SID} cid={pageCID} jobPage={props.jobPage} qs={props.qs} seJk={seJk} hostedType={hostedType} queryString2={queryString2} onFormSubmit={onFormSubmit} updateEmail={setEmail} email={email} updateFName={setFName} updateLName={setLName} updatePhone={setPhone} phone={phone} fname={fname} lname={lname} queryString={parsedQuery} loading={loading} showLoad={showLoad} hideLoad={hideLoad} redirectBaseUrl={props.redirectBaseUrl} />
	                    </Fragment>
	                }
	                {
	                    page === "number"
	                    &&
	                    <Fragment>
	                        <p>What mobile number should a hiring manager use to contact you?</p>
	                        <PhoneForm sessionId={props.sessionId} jobSearch={props.jobSearch} jobLocation={props.jobLocation} jobTitle={props.jobTitle} sid={props.SID} cid={pageCID} jobPage={props.jobPage} qs={props.qs} hasResume={props.hasResume} goResults2={goResults2} hidePhone={hidePhone} hostedType={hostedType} onFormSubmit={onFormSubmit} email={email} updatePhone={setPhone} phone={phone} queryString={parsedQuery} queryString2={queryString2} loading={loading} showLoad={showLoad} hideLoad={hideLoad} redirectBaseUrl={props.redirectBaseUrl} />
	                    </Fragment>
	                }
	                {
	                    page === "coreg"
	                    &&
	                    <Fragment>
	                        <p style={{"max-width": "435px"}}>Sign up below for our awesome partners</p>
	                        <CoRegForm qs={props.qs} jobState={props.coregJobState} goResults2={goResults2} hidePhone={hidePhone} hostedType={hostedType} onFormSubmit={onFormSubmit} email={email} updatePhone={setPhone} phone={phone} queryString={parsedQuery} queryString2={queryString2} loading={loading} showLoad={showLoad} hideLoad={hideLoad} redirectBaseUrl={props.redirectBaseUrl} />
	                    </Fragment>
	                }
	                {
	                    page === "customForm"
	                    &&
	                    <Fragment>
	                        <CustomForm onFormSubmit={onFormSubmit} deFormJson={props.deFormJson}/>
	                    </Fragment>
	                }
	                {
	                    page === "uploadResume"
	                    &&
	                    <Fragment>
	                        <button type="button" className="close btnAltClose float-right" onClick={((props.resumeNeeded === 'y' && (hostedType.toLowerCase() === "hosted" || hostedType.toLowerCase() === "hosted_plus")) ? () => onCloseModal() : (hostedType.toLowerCase() === "hosted" || hostedType.toLowerCase() === "hosted_plus") ? () => onFormSubmit('customForm') : (props.duplicateUser === false && props.jobPage === "8" ? () => offerGoNext() : () => goResults2()))}>×</button>
	                        <UploadResume sid={props.SID} siteId={props.siteId} keyMapId={props.keymapid} cid={props.CID} zip={zip} hostedType={hostedType} onFormSubmit={onFormSubmit} updateResumeFileName={setFileName} loading={loading} showLoad={showLoad} hideLoad={hideLoad} queryString3={queryString3} />
	                    </Fragment>
	                }
	                {
	                    page === 'uploadFile'
	                    &&
	                    <Fragment>
	                        <button type="button" className="close btnAltClose float-right" onClick={((props.resumeNeeded === 'y' && (hostedType.toLowerCase() === "hosted" || hostedType.toLowerCase() === "hosted_plus")) ? () => onCloseModal() : (hostedType.toLowerCase() === "hosted" || hostedType.toLowerCase() === "hosted_plus") ? () => onFormSubmit('customForm') : (props.duplicateUser === false && props.jobPage === "8" ? () =>  offerGoNext() : () => goResults2()))}>×</button>
	                        <UploadResumeFile zip={zip} hostedType={hostedType} onFormSubmit={onFormSubmit} loading={loading} showLoad={showLoad} hideLoad={hideLoad} queryString3={queryString3} />
	                    </Fragment>
	                }
	                {
	                    page === "easyApply"
	                    &&
	                    <Fragment>
	                        <button type="button" className="close btnAltClose float-right" onClick={((hostedType.toLowerCase() === "hosted" || hostedType.toLowerCase() === "hosted_plus") ? () => onFormSubmit('customForm') : (props.duplicateUser === false && props.jobPage === "8" ? () =>  offerGoNext() : () => goResults2()))}>×</button>
	                        <EasyApplyForm zip={zip} hostedType={hostedType} onFormSubmit={onFormSubmit} queryString={parsedQuery} queryString3={queryString3} updateFName={setFName} updateLName={setLName} updateRecentJob={setRecentJob} updateRecentCompany={setRecentCompany} recentJob={recentJob} recentCompany={recentCompany} loading={loading} showLoad={showLoad} hideLoad={hideLoad} fname={fname} lname={lname} />
	                    </Fragment>
	                }
	                {
	                    page === "finishResume"
	                    &&
	                    <Fragment>
	                        <button type="button" className="close btnAltClose float-right" onClick={() => goResults2()}>×</button>
	                        <h4>Finish your application on the employer's site</h4>
	                        <p>To complete your application, the employer requires you finish on their site.</p>
	                    </Fragment>
	                }
                	{
	                    page === "applicationComplete"
	                    &&
	                    <Fragment>
	                        <button type="button" className="close btnAltClose float-right" onClick={() => goResults2()}>×</button>
	                        {
	                            (hostedType.toLowerCase() === "direct" || hostedType.toLowerCase().toLowerCase() !== "hosted" || hostedType.toLowerCase() === "")
	                            &&
	                            <div id="continueBox" style={{ 'text-align': 'center' }}>
	                                <h3 className="center">Finish your application on the employer's site</h3>
	                                <p>To complete your application, the employer requires you finish on their site.</p>
	                                <button id="continueApp" className="btn" type="button" style={{ 'margin-top': '0' }} onClick={() => goResults2()}>Continue</button>
	                            </div>
	                        }
	                        {
	                            hostedType.toLowerCase() === "hosted"
	                            &&
	                            <div>
	                                <h3 className="center">Your application has been submitted.</h3>
	                                <p>Be sure to check your email <span className="userEmail">({email})</span> and phone often as employers may try to contact you soon.</p>
	                            </div>
	                        }
	                    </Fragment>
	                }
	                <Fragment>
	                    <TermsTextLanguage termsText={props.termsText} page={page} domain={domainOut} hostedType={hostedType} setShowRegOverlay={props.setShowRegOverlay} setShowCarriers={props.setShowCarriers} redirectBaseUrl={props.redirectBaseUrl} />
	                </Fragment>
                </div>
            </div>
        </Modal>
        <div id="offerLoad" className="loading" style={{'zIndex':9999, 'background':'none'}}><div className="spinner"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div></div>

        {currentOffer && <OffersOverlay setCurrentOffer={setCurrentOffer} jobURL={props.jobURL} qs={props.qs} offer={currentOffer} offerGoNext={offerGoNext} CID={props.CID} ccT={props.ccT} SID={props.SID} isMobile={props.isMobile} />}
        </>
    )
}

export default withRouter(RegOverlay);